/*
 * @Author: Nanxing Xiang
 * @Date: 2021-08-31 14:40:07
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-09-03 15:25:53
 * @Description: file content
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export default i18n.use(initReactI18next).init({
  resources: {
    en: {},
    tc: {},
    sc: {}
  },
  fallbackLng: 'cn',
  debug: false,
  interpolation: {
    escapeValue: false
  }
});
